@if (existingCustomerChecked()) {
  <wl-order-redirect-to-mijn
    [rendering]="rendering()"
    [content]="content()"
    wlAutomationId="order-redirect-to-mijn"
    (continueAsNewCustomer)="continueAsNewCustomer()"
  />
}
<wl-order-fulfillment-personal
  wlAutomationId="order-fulfillment-personal"
  [progressiveFormState]="fulfillmentPersonalProgressiveFormState()"
  [rendering]="rendering()"
  [orderContent]="content()"
  [genderOptions]="genderOptions()"
  [stepNumber]="stepNumber(ORDER_STEP.ORDER_PERSONAL_STEP)"
  [labelsShownAboveFields]="content().labelsShownAboveFields"
/>
<wl-order-fulfillment-address
  [progressiveFormState]="fulfillmentAddressProgressiveFormState()"
  [rendering]="rendering()"
  [orderContent]="content()"
  [residenceOrWorkplaceOptions]="residenceOrWorkplaceOptions()"
  [exclusivelyCorporateUsageOptions]="exclusivelyCorporateUsageOptions()"
  [supplyAddress]="supplyAddressVM()"
  [correspondenceAddress]="correspondenceInstallationAddressState()"
  [correspondenceHouseNumberExtensions]="correspondenceHouseNumberExtensions()"
  [stepNumber]="stepNumber(ORDER_STEP.ORDER_ADDRESS_STEP)"
  [labelsShownAboveFields]="content().labelsShownAboveFields"
  (changeSupplyAddress)="changeSupplyAddress()"
  (inswitchOpenLegalModal)="inswitchOpenLegalModal()"
/>
@let product = crossSellProduct();
@if (crossSellFeatureEnabled() && !!product) {
  <wl-order-fulfillment-cross-sell
    [progressiveFormState]="fulfillmentCrossSellProgressiveFormState()"
    [rendering]="rendering()"
    [orderContent]="content()"
    [stepNumber]="stepNumber(ORDER_STEP.ORDER_CROSS_SELL_STEP)"
    [product]="product"
  />
}
<wl-order-fulfillment-payment
  [progressiveFormState]="fulfillmentPaymentProgressiveFormState()"
  [rendering]="rendering()"
  [orderContent]="content()"
  [stepNumber]="stepNumber(ORDER_STEP.ORDER_PAYMENT_STEP)"
  [labelsShownAboveFields]="content().labelsShownAboveFields"
/>
<wl-order-fulfillment-confirmation
  [progressiveFormState]="fulfillmentConfirmationProgressiveFormState()"
  [rendering]="rendering()"
  [orderContent]="content()"
  [offer]="offer()"
  (openAOMModal)="openAOMModal($event)"
  [stepNumber]="stepNumber(ORDER_STEP.ORDER_CONFIRMATION_STEP)"
/>
